// extracted by mini-css-extract-plugin
export default {"wrapper":"cb_dt","link":"cb_f8","imageContainer":"cb_fz","image":"cb_dx","textContainer":"cb_dF","title":"cb_cX","description":"cb_c","mark":"cb_jr"};